import * as React from 'react';

import { PostCardLayoutLongread, PostCardLayoutWithSidebar } from '../../components/PostCardLayouts';

export const PostCard = () => {
  const layoutType: 'with-sidebar' | 'longread' = 'with-sidebar';
  // @ts-ignore
  const LayoutComponent = layoutType === 'longread' ? PostCardLayoutLongread : PostCardLayoutWithSidebar;

  return (
    <LayoutComponent>
      Одиночная страница типа Лонгрид
      <div style={{ background: 'lightblue', height: '300px' }}>Картинка</div>
    </LayoutComponent>
  );
};
